import { JSX, useEffect, useRef } from 'react'

import { KeyboardContext } from './KeyboardContext'
import { IKeyboardEvent } from './models'

interface IKeyboardControllerProps {
  children: JSX.Element | JSX.Element[]
}

export const KeyboardController = (props: IKeyboardControllerProps) => {
  const callbacksRef = useRef<Array<Array<IKeyboardEvent>>>([])
  const callbacks = callbacksRef.current

  useEffect(() => {
    const keyHandler = (e: KeyboardEvent) => {
      if (callbacks.length > 0) {
        for (let i = callbacks.length - 1; i >= 0; i--) {
          for (const comb of callbacks[i]) {
            if (!comb.shiftKey) {
              comb['shiftKey'] = false
            }
            if (!comb.ctrlKey) {
              comb['ctrlKey'] = false
            }
            if (!comb.altKey) {
              comb['altKey'] = false
            }
            if (!comb.metaKey) {
              comb['metaKey'] = false
            }
            if (
              comb.key === e.key &&
              comb.shiftKey === e.shiftKey &&
              comb.ctrlKey === e.ctrlKey &&
              comb.altKey === e.altKey &&
              comb.metaKey === e.metaKey
            ) {
              e.preventDefault()
              comb.fn()
              return
            }
          }
        }
      }
    }
    window.addEventListener('keydown', keyHandler)
    return () => {
      window.removeEventListener('keydown', keyHandler)
    }
  }, [callbacks])

  return (
    <KeyboardContext.Provider
      value={{
        registr: (pressHandler: Array<IKeyboardEvent>) => {
          callbacks.push(pressHandler)
          return {
            priorifize: () => {
              const toBeFocused = callbacks.findIndex((arr) => arr === pressHandler)
              if (toBeFocused > -1) {
                callbacks.push(callbacks[toBeFocused])
                callbacks.splice(toBeFocused, 1)
              }
            },
            unregistr: () => {
              const findIndex = callbacks.findIndex((arr) => arr === pressHandler)
              if (findIndex > -1) {
                callbacks.splice(findIndex, 1)
              }
            },
          }
        },
      }}
    >
      <>{props.children}</>
    </KeyboardContext.Provider>
  )
}
